import type { TypePolicies } from '@apollo/client/cache';

import { getMaxFgwMachineCount } from 'common/components/clusters/fgw/AzureRouteServer/helpers';

import authSettingsFieldPolicy from './field_policies/authSettingsFieldPolicy';
import { paginationListPolicy, paginationPolicy } from './field_policies/pagination';
import permissionsFieldPolicy from './field_policies/permissionsFieldPolicy';
import userActivitiesFieldPolicy from './field_policies/userActivitiesFieldPolicy';

export const getTypePolicies = (): TypePolicies => {
  return {
    Account: {
      fields: {
        users: paginationPolicy(),
        authSettings: authSettingsFieldPolicy,
        userActivities: userActivitiesFieldPolicy(),
        userVolumes: paginationPolicy(),
        tasks: paginationPolicy(),
        notifications: paginationPolicy(),
        userVolumesSettings: {
          merge: true,
        },
        settings: {
          merge: true,
        },
        persistentDesktopSettings: {
          merge: true,
        },
        persistentDesktopServers: paginationPolicy(),
        cloudService: {
          merge: true,
        },
        domainJoin: {
          merge: true,
        },
      },
    },
    Pool: {
      fields: {
        settings: {
          merge: true,
        },
      },
    },
    Customer: {
      fields: {
        users: paginationPolicy(),
        notifications: paginationPolicy(),
        authSettings: authSettingsFieldPolicy,
        userActivities: userActivitiesFieldPolicy(),
        tasks: paginationPolicy(),
      },
    },
    Organization: {
      fields: {
        users: paginationPolicy(),
        notifications: paginationPolicy(),
        authSettings: authSettingsFieldPolicy,
        userActivities: userActivitiesFieldPolicy(),
        tasks: paginationPolicy(),
      },
    },
    PermissionScope: {
      fields: {
        permissions: permissionsFieldPolicy,
      },
    },
    Backups: {
      fields: {
        list: paginationListPolicy(),
      },
    },
    User: {
      fields: {
        notifications: paginationPolicy(),
        tasks: paginationPolicy(),
      },
    },
    Query: {
      fields: {
        accounts: paginationPolicy(),
        organizations: paginationPolicy(),
        customers: paginationPolicy(),
        clusters: paginationPolicy(),
        auditTrails: paginationPolicy(),
      },
    },
    InstanceType: {
      fields: {
        bandwidth: {
          read(_, { readField }) {
            const displayName = readField('displayName');

            switch (displayName) {
              case 'Small': {
                return 10;
              }
              case 'Large': {
                return 16;
              }
              default: {
                return 10;
              }
            }
          },
        },
      },
    },
    AzureRouteServer: {
      fields: {
        maxMachines: {
          read(_, { readField }) {
            const bgpConnectionsCount = readField('bgpConnectionsCount');

            return getMaxFgwMachineCount(Number(bgpConnectionsCount));
          },
        },
      },
    },
  };
};
